module.exports = __webpack_public_path__ + "media/colors/JASPEM2-3-5af1126e.png";